import { format, toZonedTime } from "date-fns-tz";

export const formatShortDate = (date: Date | string | number) => {
  const zonedDate = convertUtcToEst(date);

  return format(zonedDate, "MM/dd/yy h:mm a");
};

export const formatLongDate = (date: Date | string | number) => {
  return format(date, "EEE, MMM d, yyyy h:mm a");
};

export const formatShortDateIgnoreTz = (date: string) => {
  const dateInUTC = toZonedTime(date, "UTC");

  return format(dateInUTC, "yyyy-MM-dd");
};

export const convertUtcToEst = (utcDateStr: Date | string | number): Date => {
  const timeZone = "America/New_York"; // Handles EST/EDT automatically
  const date = new Date(utcDateStr);

  return toZonedTime(date, timeZone);
};

type ReplaceKeysWith<T, K extends keyof T, V> = {
  [P in keyof T]: P extends K ? V : T[P];
};

export const convertAllDatesToEst = <T extends Record<string, unknown>, K extends keyof T>(
  obj: T,
  dateKeys: K[],
): ReplaceKeysWith<T, K, Date> => {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => {
      if (dateKeys.includes(key as K) && value !== null) {
        return [key, convertUtcToEst(value as string)];
      }

      return [key, value];
    }),
  ) as ReplaceKeysWith<T, K, Date>;
};
